(function() {

    'use strict';

    var DropZone = function DropZone(element) {

        var self = this,
            uploadQueue = [],
            targetUrl,
            formData;

        self.element = element;

        if(self.element.hasAttribute('data-target')) {
            targetUrl = element.dataset.target;
        } else {
            targetUrl = window.location.href;
        }

        self.element.addEventListener('dragenter', function(e) {
            e.preventDefault();
        });

        self.element.addEventListener('dragover', function(e) {
            e.preventDefault();
        });

        self.element.addEventListener('dragleave', function(e) {
            e.preventDefault();
        });

        self.element.addEventListener('drop', function(e) {

            e.preventDefault();

            queueFiles(e.dataTransfer.files);

        });

        self.element.addEventListener('uploads:queued', function() {

            while(0 < uploadQueue.length) {
                upload(uploadQueue.shift());
            }

        });

        var emitEvent = function(name, detail) {

            var event;

            detail = detail || null;

            if(detail !== null) {

                event = new CustomEvent(name, {
                    detail: detail
                });

            } else {

                event = new CustomEvent(name);

            }

            self.element.dispatchEvent(event);

        };

        var queueFiles = function(files) {

            var i, length;

            if(files === undefined) {
                return;
            }

            length = files.length;

            for (i = 0; i < length; i++) {
                uploadQueue.push(files[i]);
            }

            emitEvent('uploads:queued');

        };

        var upload = function(file) {

            var xhr = new XMLHttpRequest(),
                token = document.querySelector("meta[name='csrf-token']").getAttribute('content');

            xhr.open('POST', targetUrl, true);

            xhr.setRequestHeader('X-CSRF-Token', token);
            xhr.setRequestHeader('Accept', 'text/javascript');

            xhr.onload = function() {

                var status = xhr.status;

                if(status !== 200) {

                    emitEvent('upload:failure', { file: file });
                    return;

                }

                emitEvent('upload:success', {
                    file: file,
                    response: xhr.response,
                    responseType: xhr.responseType
                });

            };

            xhr.upload.onprogress = function(e) {
                emitEvent('upload:progress', { status: e });
            };

            formData = new FormData();
            formData.append("attachment[data]", file);

            xhr.send(formData);

        };

    };

    var dropZoneElement = document.querySelector('.drop-zone');

    if(dropZoneElement) {

        var dropZone = new DropZone(dropZoneElement);

        dropZoneElement.addEventListener('upload:success', function(e) {

            var script = document.createElement('script');
            script.text = e.detail.response;

            document.head.appendChild(script).parentNode.removeChild(script);

        });

    }

})();